import { CustomField, CustomFieldValue } from "@web-app/types";

interface CustomFieldCellProps {
  colDef: {
    colId: string;
  };
  data: {
    customFields?: {
      definition: CustomField;
      values: CustomFieldValue[];
    }[];
  };
}

export default function CustomFieldCell(props: CustomFieldCellProps) {
  const { data, colDef } = props;

  if (!data?.customFields || !colDef?.colId) {
    return null;
  }

  const customFieldId = colDef.colId.replace("custom_field_", "");
  const customFieldData = data.customFields.find(
    (item) => item.definition.id === customFieldId,
  );

  if (!customFieldData) {
    return null;
  }

  const { definition, values } = customFieldData;

  if (!values?.length && !definition.defaultValues?.length) {
    return null;
  }

  const effectiveValues = values?.length ? values : definition.defaultValues;

  if (definition.type === "DROPDOWN" && definition.isMulti) {
    const selectedValues = effectiveValues
      .filter((v) => v.value)
      .map((v) => {
        const option = definition.options?.find((opt) => opt.value === v.value);
        return option?.label || String(v.value);
      });

    if (selectedValues.length === 0) {
      return null;
    }

    return (
      <div className="flex flex-wrap gap-1 py-1">
        {selectedValues.map((displayLabel, index) => (
          <span
            key={index}
            className="inline-flex items-center px-2 py-0.5 rounded-md bg-gray-100 text-black text-xs"
          >
            {displayLabel}
          </span>
        ))}
      </div>
    );
  }

  if (definition.type === "DROPDOWN" && !definition.isMulti) {
    const selectedValue = effectiveValues.find((v) => v.value);
    if (!selectedValue) {
      return null;
    }

    const option = definition.options?.find(
      (opt) => opt.value === selectedValue.value,
    );
    const displayLabel = option?.label || String(selectedValue.value);

    return <span className="text-sm text-gray-700">{displayLabel}</span>;
  }

  const value = effectiveValues[0]?.value;
  if (!value) {
    return null;
  }

  return <span className="text-sm text-gray-700">{String(value)}</span>;
}
